let common = {
  //echarts toolTipzi自动播放
  moveEcharts(lent, name) {
    var currentIndex = -1
    var dataLen = lent;
    setInterval(() => {
      // 取消之前高亮的图形
      if (currentIndex > -1){
        name.dispatchAction({
          type: 'downplay',
          seriesIndex: 0,
          dataIndex: currentIndex
        });
      }
      currentIndex = (currentIndex + 1) % dataLen
      // 高亮当前图形
      name.dispatchAction({
        type: 'highlight',
        seriesIndex: 0,
        dataIndex: currentIndex
      });
      // 显示 tooltip
      name.dispatchAction({
        type: 'showTip',
        seriesIndex: 0,
        dataIndex: currentIndex
      });
    }, 4500);
  },
  //格式化数字
  formatNum(num) {
    let res = num.toString();
    if (res.length > 3) {
      let pattern = /(\d)(\d{2})/mg;
      return res.replace(pattern, '$1' + ',' + '$2')
    } else {
      return num;
    }
  }
}

export default common